<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BUJISV/tc-custom/9780310352167.jpg?1705026307385" alt="This image is the cover for the book Story Devotional"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Story Devotional
      </h1>
      <p class="bookDescription body article font2">
        <p>Like <i>The Story</i>, <i>The Story Devotional</i> will guide readers through the overarching narrative of the Bible in 365 days. Combining Scripture with bite-sized reflections and a daily takeaway, readers will be able to work their way through God's epic Story and focus on His plan for their lives. Following the same chronological organization as <i>The Story</i>, readers will see their lives in a whole new light, with purpose as part of God's eternal story. Using the takeaway message at the end of each devotion, readers can apply the teachings of the Bible to their daily life. This book can be used in conjunction with <i>The Story</i> or as a stand alone devotional.</p><p>This is the first devotional product in <i>The Story</i> line.</p><p>Trim Size: 5 x 7</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zondervan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Zondervan
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0ce98f03